'use client';

import { StyledTooltipContainer } from '@components/InternalIcons/Tooltip.styled';
import { openInternalPopup } from '@components/InternalIcons/utils/internalPopup';
import { Flex, IconButton } from '@coolblue-development/freddy';
import selectOptionTrigger from '@coolblue-development/ga4-events/triggers/InternalIcons/selectOptionTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ReactElement } from 'react';

export default function IrisIcon({
  url,
  index,
  totalIndices
}: {
  url: string;
  index: number;
  totalIndices: number;
}): ReactElement {
  const iconLabel = 'Open Iris product dashboard';
  const { trackEvent } = useAnalytics();

  return (
    <Flex alignItems='center'>
      <StyledTooltipContainer data-internal-icons-tooltip={iconLabel} data-testid='iris-icon'>
        <IconButton
          aria-label={iconLabel}
          size='small'
          onClick={() => {
            trackEvent(
              selectOptionTrigger({
                sub_feature: 'iris',
                index: index,
                total_indices: totalIndices,
                selection_type: 'selected',
                option_name: 'iris',
                attribute: 'iris'
              })
            );
            openInternalPopup(url);
          }}
          sx={theme => ({
            padding: '0.6rem',
            svg: {
              width: theme.spacing[500],
              height: theme.spacing[500]
            }
          })}
        >
          <IconElement />
        </IconButton>
      </StyledTooltipContainer>
    </Flex>
  );
}

const IconElement = () => {
  return (
    <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_87_30725)'>
        <mask
          id='mask0_87_30725'
          style={{ maskType: 'luminance' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='21'
          height='21'
        >
          <path d='M20.5 0.5H0.5V20.5H20.5V0.5Z' fill='white' />
        </mask>
        <g mask='url(#mask0_87_30725)'>
          <path
            d='M2.5 12.1C2.5 16.52 6.08 20.1 10.5 20.1C14.92 20.1 18.5 16.52 18.5 12.1C18.5 7.67998 14.92 4.09998 10.5 4.09998C6.08 4.09998 2.5 7.67998 2.5 12.1Z'
            fill='#CCE9F9'
          />
          <path
            d='M7.96004 1.13002C6.06004 1.79002 2.35004 6.81002 2.83004 9.84002C3.34004 13.07 5.70004 16.58 5.70004 16.58C9.07004 14.51 12.41 14.43 14.47 14.67L15.44 13.07V14.85C16.08 14.96 16.45 15.08 16.45 15.08C16.45 15.08 18.12 12.78 17.42 7.43002C16.78 2.57002 10.85 0.120016 7.96004 1.13002Z'
            fill='black'
          />
          <path
            d='M12.81 16.06C12.81 16.06 11.33 15.38 10.65 15.54C9.96997 15.7 8.58997 16.43 8.58997 16.43L10.06 19.41L12.53 18.5L12.81 16.06Z'
            fill='#285DAB'
          />
          <g style={{ mixBlendMode: 'multiply' }}>
            <path
              d='M9.91003 12.73H11.56C11.56 12.73 11.43 13.41 11.48 14.84L10.04 14.37C10.01 13.23 9.91003 12.72 9.91003 12.72V12.73Z'
              fill='#B3B3B3'
            />
          </g>
          <path
            d='M5.75996 9.28001C5.98996 11.93 7.93996 14.07 11.23 13.65C14.52 13.23 15.59 11.12 15.36 8.46002C15.13 5.81002 12.8 3.84002 10.15 4.07002C7.49996 4.30002 5.52996 6.63001 5.75996 9.28001Z'
            fill='#F8A98F'
          />
          <path
            d='M4.18994 8.81002C8.59994 7.33002 11.7399 7.21002 11.7399 7.21002L11.8899 5.68002L12.6299 7.17002L15.8699 7.29002L13.2399 3.79002L7.87994 3.02002L4.19994 8.81002H4.18994Z'
            fill='black'
          />
          <path
            d='M4.83001 9.08005C5.03001 9.85005 5.83001 10.55 6.18001 10.74C6.61001 10.63 6.64001 9.71005 6.44001 8.93005C6.24001 8.16005 5.61001 7.62005 5.17001 7.73005C4.74001 7.84005 4.62001 8.30005 4.82001 9.08005H4.83001Z'
            fill='#F8A98F'
          />
          <path
            d='M7.13 10.5701C7.13 10.5701 9.26 14.1001 12.49 11.7301C8.75 12.1301 7.13 10.5701 7.13 10.5701Z'
            fill='#BF4949'
          />
          <mask
            id='mask1_87_30725'
            style={{ maskType: 'luminance' }}
            maskUnits='userSpaceOnUse'
            x='2'
            y='4'
            width='17'
            height='17'
          >
            <path
              d='M2.5 12.1C2.5 16.52 6.08 20.1 10.5 20.1C14.92 20.1 18.5 16.52 18.5 12.1C18.5 7.67998 14.92 4.09998 10.5 4.09998C6.08 4.09998 2.5 7.67998 2.5 12.1Z'
              fill='white'
            />
          </mask>
          <g mask='url(#mask1_87_30725)'>
            <path
              d='M11.56 12.73C11.56 12.73 11.25 15.29 11.76 17.04C12.27 18.79 14.64 20.07 14.64 20.07L11.56 22.18L7.98999 20.44C7.98999 20.44 9.60999 19.35 9.90999 17.09C10.22 14.83 9.90999 12.74 9.90999 12.74H11.56V12.73Z'
              fill='#F8A98F'
            />
            <path
              d='M8.58 16.4299L10.32 18.9199L11.37 20.3799L12.01 18.8999L12.83 16.0699V17.5999L15.92 21.3699C14.38 22.3599 12.54 22.9299 10.58 22.9299C9.13 22.9299 7.75 22.6199 6.5 22.0499L8.88 17.8699L8.58 16.4299Z'
              fill='#0090E3'
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_87_30725'>
          <rect width='20' height='20' fill='white' transform='translate(0.5 0.5)' />
        </clipPath>
      </defs>
    </svg>
  );
};
